"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketLifecycleInput_1 = require("./GetBucketLifecycleInput");
var GetBucketLifecycleOutput_1 = require("./GetBucketLifecycleOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketLifecycle = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketLifecycle",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?lifecycle"
    },
    input: {
        shape: GetBucketLifecycleInput_1.GetBucketLifecycleInput
    },
    output: {
        shape: GetBucketLifecycleOutput_1.GetBucketLifecycleOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketLifecycle.js.map